import { render } from "./Part_Header.vue?vue&type=template&id=f6549638&scoped=true"
import script from "./Part_Header.vue?vue&type=script&lang=js"
export * from "./Part_Header.vue?vue&type=script&lang=js"

import "./Part_Header.vue?vue&type=style&index=0&id=f6549638&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6549638"]])

export default __exports__